export const enableDarkMode = () => {
  document.documentElement.classList.add('dark');
};
